var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "4elfras68a",
    d: "M4.837.163c.217.22.217.576 0 .795L1.806 4.02 13.5 4.02c.276 0 .5.224.5.5 0 .245-.177.45-.41.492l-.09.008-11.653-.001 2.99 3.023c.217.219.217.575 0 .795-.215.217-.563.217-.778 0L.163 4.897c-.217-.219-.217-.575 0-.795L4.059.163c.215-.217.563-.217.778 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1099 -27) translate(1071) translate(28 27) translate(1 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "in4piw0ftb",
    fill: "#010101"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#4elfras68a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#010101",
    fillRule: "nonzero",
    xlinkHref: "#4elfras68a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#010101",
    mask: "url(#in4piw0ftb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(-1 -3)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowBlack);
export default __webpack_public_path__ + "static/media/left-arrow-black.5bfb3dac2ae0ccc5624cef37ff45b5a0.svg";
export { ForwardRef as ReactComponent };